export default __webpack_public_path__ + "static/media/AuthLighthouse.51b09721.png";